export const ratingColors = {
  excellent: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400",
  good: "bg-cyan-100 text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-400",
  satisfactory: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  needs_improvement: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
  unsatisfactory: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",
};

export const ratingLabels = {
  excellent: "Excellent", good: "Good", satisfactory: "Satisfactory",
  needs_improvement: "Needs Improvement", unsatisfactory: "Unsatisfactory",
};

export const kpiStatusColors = {
  on_track: "bg-emerald-100 text-emerald-700", at_risk: "bg-amber-100 text-amber-700",
  breached: "bg-red-100 text-red-700", exceeded: "bg-cyan-100 text-cyan-700",
};

export const changeImpactColors = { low: "bg-blue-100 text-blue-700", medium: "bg-amber-100 text-amber-700", high: "bg-red-100 text-red-700" };
export const changeStatusColors = { proposed: "bg-slate-100 text-slate-700", approved: "bg-emerald-100 text-emerald-700", rejected: "bg-red-100 text-red-700", implemented: "bg-cyan-100 text-cyan-700" };

export const reviewStatusColors = { scheduled: "bg-blue-100 text-blue-700", completed: "bg-emerald-100 text-emerald-700", overdue: "bg-red-100 text-red-700", cancelled: "bg-slate-100 text-slate-700" };

export const contractStatusColors = {
  draft: "bg-slate-100 text-slate-700", under_review: "bg-amber-100 text-amber-700",
  pending_approval: "bg-blue-100 text-blue-700", approved: "bg-emerald-100 text-emerald-700",
  active: "bg-cyan-100 text-cyan-700", expired: "bg-red-100 text-red-700",
  terminated: "bg-gray-100 text-gray-700", archived: "bg-purple-100 text-purple-700",
};

export const formatDate = (d) => {
  if (!d) return "-";
  return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

export const formatCurrency = (v, ccy) => {
  if (v === null || v === undefined || v === "" || v === 0) return "-";
  try {
    return new Intl.NumberFormat("en-GB", { style: "currency", currency: ccy || "GBP", minimumFractionDigits: 0 }).format(v);
  } catch {
    return `${ccy || ""} ${Number(v).toLocaleString()}`;
  }
};
